import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

const EmailsModalSchema = (): yup.AnyObjectSchema => {
  const { t } = useTranslation();

  const nameLength = t('common.formErrorMessages.name_length');
  const nameRequired = t('common.formErrorMessages.name_required');
  const subjectLength = t('common.formErrorMessages.subject_length');
  const subjectRequired = t('common.formErrorMessages.subject_required');
  const messageRequired = t('common.formErrorMessages.message_required');
  const listType = t('common.formErrorMessages.list_type_required');

  const schema = yup
    .object({
      name: yup.string().trim().max(50, nameLength).required(nameRequired),
      type: yup
        .object()
        .nullable()
        .required(listType)
        .shape({
          label: yup.string().required(listType),
          value: yup.string().required(listType),
        }),
      subject: yup
        .string()
        .trim()
        .max(998, subjectLength)
        .required(subjectRequired),
      message: yup.string().trim().required(messageRequired),
    })
    .required();

  return schema;
};

export default EmailsModalSchema;
